var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ifrm_jump"},[_c('iframe',{ref:"maidIframe",staticClass:"height100",staticStyle:{"width":"100%"},attrs:{"src":_vm.url,"frameborder":"0","id":"maidIframe"}})])}
var staticRenderFns = []

export { render, staticRenderFns }